module.exports = __webpack_public_path__ + "img/memoirerings.1b7aa4c.jpg";